import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

export const PST_TIMEZONE = 'America/Los_Angeles';

// Strings with an explicit UTC offset (e.g. from Prismic: "2026-05-11T21:00:00+0000")
// must be parsed first so the offset is respected before converting to PST.
// Timezone-naive strings (e.g. "2023-05-01 08:30") are treated as PST directly.
const hasUtcOffset = (dateStr: string) =>
  /Z$|[+-]\d{2}:?\d{2}$/.test(dateStr.trim());

export const parseDateInPST = (dateStr: string, tz: string = PST_TIMEZONE) =>
  hasUtcOffset(dateStr) ? dayjs(dateStr).tz(tz) : dayjs.tz(dateStr, tz);

export const isWithinDateRangePST = (
  startDate = '0001-01-01',
  endDate = '9999-12-31'
) => {
  if (process.env.NEXT_PUBLIC_NYD_DATE_OVERRIDE === 'true') {
    return true;
  }

  try {
    const now = dayjs().tz(PST_TIMEZONE);
    const start = parseDateInPST(startDate, PST_TIMEZONE);
    let end = parseDateInPST(endDate, PST_TIMEZONE);

    // If endDate has no time (defaults to midnight), adjust to end of day
    if (end.isSame(end.startOf('day'))) {
      end = end.endOf('day');
    }

    return now.isBetween(start, end, null, '[]');
  } catch (error) {
    console.error('Error checking date range:', error);
    return false;
  }
};
